var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$hideUserAccountRelatedFunctions)?_c('div',{class:_vm.parentClass,on:{"click":function($event){$event.preventDefault();return _vm.showMerklisteModal.apply(null, arguments)}}},[_c('span',{staticClass:"icon",class:_vm.isInCollectionClass},[_c('img',{attrs:{"src":_vm.getIcon,"alt":"Bookmark-icon"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }